var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "messageModal",
      attrs: { id: "staff-message", title: _vm.title },
      on: { ok: _vm.sendMessage }
    },
    [
      _c("div", { staticClass: "form-group inline-label" }, [
        _c(
          "label",
          {
            staticClass: "label-bid-message",
            attrs: { for: "staff-message-textarea" }
          },
          [
            _vm._v("\n            Message\n            "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.addEmojiMessage("&#x1F6AD")
                  }
                }
              },
              [_vm._v("🚭")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.addEmojiMessage("&#x1F44D")
                  }
                }
              },
              [_vm._v("👍")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.addEmojiMessage("&#x1F44E")
                  }
                }
              },
              [_vm._v("👎")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.addEmojiMessage("&#x1F44C")
                  }
                }
              },
              [_vm._v("👌")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "cursor-pointer",
                on: {
                  click: function($event) {
                    return _vm.addEmojiMessage("&#x1F645")
                  }
                }
              },
              [_vm._v("🙅")]
            )
          ]
        ),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.message,
              expression: "message"
            }
          ],
          ref: "message",
          attrs: { id: "staff-message-textarea" },
          domProps: { value: _vm.message },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.message = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "preset-message-list" },
        _vm._l(_vm.default_messages, function(msg, index) {
          return _c("li", [
            _c(
              "a",
              {
                class: msg.used ? "used" : "not-used",
                attrs: { href: "#!" },
                on: {
                  click: function($event) {
                    return _vm.addToMessage(index)
                  }
                }
              },
              [_vm._v(_vm._s(msg.msg))]
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50d9b66d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50d9b66d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSingle/StaffMessage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-50d9b66d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSingle/StaffMessage.vue
// module chunks = 0